(() => {
  const slugify = (value) =>
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const initializeTableOfContents = (container) => {
    if (container.dataset.initialized === 'true') return;

    const section = container.closest('.section-content-wrapper');
    const content = section?.querySelector('.blog-post-content');
    const list = container.querySelector('[data-blog-post-toc-list]');
    const headings = content ? [...content.querySelectorAll('h2, h3')] : [];

    if (!list || headings.length < 2) return;

    const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
    let currentParentItem = null;
    let currentNestedList = null;

    headings.forEach((heading, index) => {
      if (!heading.id) {
        const baseId = slugify(heading.textContent.trim()) || `article-section-${index + 1}`;
        let headingId = baseId;
        let suffix = 2;

        while (usedIds.has(headingId)) {
          headingId = `${baseId}-${suffix}`;
          suffix += 1;
        }

        heading.id = headingId;
        usedIds.add(headingId);
      }

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);

      if (heading.tagName === 'H3' && currentParentItem) {
        if (!currentNestedList) {
          currentNestedList = document.createElement('ol');
          currentParentItem.append(currentNestedList);
        }
        currentNestedList.append(item);
        return;
      }

      list.append(item);
      currentParentItem = item;
      currentNestedList = null;
    });

    container.hidden = false;
    container.dataset.initialized = 'true';
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-blog-post-toc]').forEach(initializeTableOfContents);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
